import { render, staticRenderFns } from "./EventViewTabSelector.vue?vue&type=template&id=1278a25c&scoped=true&"
import script from "./EventViewTabSelector.vue?vue&type=script&lang=ts&"
export * from "./EventViewTabSelector.vue?vue&type=script&lang=ts&"
import style0 from "./EventViewTabSelector.vue?vue&type=style&index=0&id=1278a25c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1278a25c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VIcon,VSpacer,VToolbar,VToolbarTitle})
